var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 79,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 57,
    height: 57,
    x: 8,
    y: 10,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 10h57v57H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13a3 3 0 0 1 3-3h50a3 3 0 0 1 3 3v50a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V13Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 13a3 3 0 0 1 3-3h50a3 3 0 0 1 3 3v50a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE2E8",
    d: "M8 10h56H8Zm57 53a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4c0 1.105 1.343 2 3 2h50a2 2 0 0 0 2-2h2ZM8 66V10v56Zm53-56a4 4 0 0 1 4 4v49a4 4 0 0 1-4 4v-2a2 2 0 0 0 2-2V13c0-1.657-.895-3-2-3Z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 9,
    x: 16,
    y: 18,
    fill: "#E3E8EF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CC3D00",
    strokeLinecap: "round",
    d: "m49.5 19.5 6 6m0-6-6 6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 6,
    x: 16,
    y: 36,
    fill: "#E3E8EF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 6,
    x: 16,
    y: 44,
    fill: "#E3E8EF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 6,
    x: 16,
    y: 52,
    fill: "#E3E8EF",
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 73,
    height: 73,
    x: 4,
    y: 6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.909804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_884",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.c20e144182d9af35cde59e39d9afe632.svg";
export { ForwardRef as ReactComponent };